export const mutations = {
  setAggregationData(state, payload) {
    state.aggregationData = payload;
  },
  setTagTotal(state, payload) {
    state.tagTotal = payload;
  },
};
